import RoutesOne from './Routes/Routes'
import NavBar from "./Components/NavBar/NavBar"
import { ToastContainer } from 'react-toastify'

/* pra user o chaveamento de tema,
import { useAppTheme } from "./Providers/ThemeContext/ThemeContext"
*/
import 'react-toastify/dist/ReactToastify.css'
import MonitoramentoPage from './Pages/MonitoramentoPage/MonitoramentoPage'
import { useContext, useEffect } from 'react'
import { UserContext } from './Providers/UserContext/UserContex'

const App = () => {
    /* pra user o chaveamento de tema, só passar o toggleTheme para  o onclick
    const { toggleTheme } = useAppTheme()
    */
    const { user } = useContext(UserContext)

    useEffect(() => {
        setTimeout(() => {
            const nome_revenda = localStorage.getItem('nome_revenda') || ''
            if (user && user.nome && user.nome !== '' && nome_revenda && nome_revenda !== '') {
                let script = document.createElement('script')
                script.async = true
                script.innerHTML = `
                document.addEventListener('spPopupsLoaded', function () {
                    window.sp.popups.variables({
                        "nome": "${user.nome} - ${nome_revenda}",
                        "empresa": "${nome_revenda}"
                    });
                });
            `
                document.body.appendChild(script)

                script = document.createElement('script')
                script.src = "https://static.wdgtsrc.com/assets/loader.js"
                script.dataset.chatsWidgetId = "e806bde1-d80d-4f09-bbaa-bf693da65294"
                script.async = true
                document.body.appendChild(script)
            } else {
            // retirar o script do body
                const script = document.body.querySelector('script')
                if (script) {
                    document.body.removeChild(script)
                }
            }
        }, 3000)
    }, [user])

    return (
        <div style={{ width: '100vw', height: '100vh', boxSizing: 'border-box' }}>
            <NavBar />
            <div style={{ width: '100%', height: 'calc(100% - 32px)', boxSizing: 'border-box' }}>
                {user && user.id != null &&
                    <MonitoramentoPage />
                }
                <RoutesOne />
            </div>
            <ToastContainer />
        </div>
    )
}

export default App
